<template>
	<div class="login-view" :class="configStore.electronMode ? 'electron' : ''">
		<AuthBackground v-if="!configStore.electronMode" />
		<div class="content">
			<!-- 密码登录表单 -->
			<el-form v-if="loginMode === 'password'" class="form" :model="loginForm" status-icon :rules="rules"
				ref="loginForm" @keyup.enter.native="submitForm()" v-loading="loading"
				:element-loading-text="$t('login.logging')">
				<div class="form-header">
					<h1 class="form-welcome">{{ $t('login.welcome') }}</h1>
					<p class="form-welcome-subtitle">{{ $t('login.welcomeSubtitle') }}</p>
				</div>
				<div class="form-body">
					<el-form-item prop="terminal" v-show="false">
						<el-input type="terminal" v-model="loginForm.terminal"></el-input>
					</el-form-item>
					<el-form-item prop="userName">
						<el-input type="userName" v-model="loginForm.userName" :placeholder="loginNamePlaceholder"
							prefix-icon="el-icon-user"></el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input type="password" v-model="loginForm.password" :placeholder="$t('login.password')"
							prefix-icon="el-icon-lock"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="nav-tool-bar">
							<el-checkbox v-model="isAutoLogin">{{ $t('login.autoLogin') }}</el-checkbox>
							<router-link v-if="containsPhoneMode || containsEmailMode" class="link"
								to="/password/reset">{{ $t('login.forgotPwd') }}</router-link>
						</div>
					</el-form-item>
					<el-button class="submit-btn" type="primary" @click="submitForm()">{{ $t('login.login')
					}}</el-button>
					<span v-if="isEnableDemo" class="demo-login-link" @click="guestLogin">
						{{ $t('login.demoLogin') }}
					</span>
				</div>
				<div class="footer-links">
					<span class="link qr-link" @click="toggleLoginMode">
						<i class="iconfont icon-scan"></i>{{ $t('login.qrLogin') }}
					</span>
					<router-link class="link" to="/register">{{ $t('login.noAccount') }}</router-link>
				</div>
			</el-form>

			<!-- 扫码登录界面 -->
			<QrLogin v-if="loginMode === 'qr'" @back="goBackToPassword" />
		</div>
		<el-dialog title="等待主设备确认" :visible.sync="deviceAuthWaiting" width="420px" :close-on-click-modal="false" :close-on-press-escape="false" @close="cancelDeviceAuth">
			<div class="device-auth-waiting">
				<i class="el-icon-lock auth-lock"></i>
				<p>授权请求已发送到主设备。允许后，本设备将自动完成登录。</p>
				<i v-if="!backupCodeMode" class="el-icon-loading auth-loading"></i>
				<el-input v-else v-model="backupCode" maxlength="6" placeholder="请输入主设备显示的6位验证码" @keyup.enter.native="submitBackupCode" />
			</div>
			<span slot="footer">
				<template v-if="!backupCodeMode"><el-button @click="inputBackupCode">使用备用验证码</el-button></template>
				<template v-else><el-button @click="closeBackupCode">返回等待</el-button><el-button type="primary" :loading="backupSubmitting" @click="submitBackupCode">验证并登录</el-button></template>
				<el-button @click="cancelDeviceAuth">取消登录</el-button>
			</span>
		</el-dialog>
		<icp></icp>
	</div>

</template>

<script>
import Icp from '../components/common/Icp.vue'
import AuthBackground from '../components/common/AuthBackground.vue'
import QrLogin from '../components/login/QrLogin.vue'
import * as auth from '../api/auth.js'

const DEVICE_AUTH_REQUEST_KEY = 'boxim.deviceAuthRequestId';

export default {
	name: "login",
	components: {
		Icp,
		AuthBackground,
		QrLogin
	},
	data() {
		var checkUsername = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('login.inputUsername')));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('login.inputPassword')));
			}
			callback();
		};
		return {
			loading: false,
			guestInviteCode: '',
			isAutoLogin: true,
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				userName: '',
				password: ''
			},
			rules: {
				userName: [{
					validator: checkUsername,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}]
			},
			loginMode: 'password',
			deviceAuthWaiting: false,
			deviceAuthRequestId: '',
			deviceAuthTimer: null,
			backupCodeMode: false,
			backupCode: '',
			backupSubmitting: false
		};
	},
	methods: {
		submitForm() {
			this.$refs.loginForm.validate((valid) => {
				if (valid) {
					this.loading = true;
					this.$http({
						url: "/login",
						method: 'post',
						data: this.loginForm
					}).then((data) => {
						if (data.deviceAuthRequired) return this.authorizeDevice(data.deviceAuthRequestId);
						this.finishLogin(data);
					}).finally(() => {
						this.loading = false
					})
				}
			});
		},
		authorizeDevice(requestId) {
			this.deviceAuthWaiting = true;
			this.deviceAuthRequestId = requestId;
			localStorage.setItem(DEVICE_AUTH_REQUEST_KEY, requestId);
			this.pollDeviceAuth();
		},
		restoreDeviceAuth() {
			const requestId = localStorage.getItem(DEVICE_AUTH_REQUEST_KEY);
			if (!requestId) return false;
			this.deviceAuthWaiting = true;
			this.deviceAuthRequestId = requestId;
			this.pollDeviceAuth();
			return true;
		},
		pollDeviceAuth() {
			if(!this.deviceAuthWaiting||!this.deviceAuthRequestId)return;
			this.$http({url:'/login/device/status?requestId='+encodeURIComponent(this.deviceAuthRequestId),method:'get'}).then(result=>{
				if(!this.deviceAuthWaiting)return;
				if(result.status==='APPROVED'&&result.loginInfo){this.clearDeviceAuth();this.finishLogin(result.loginInfo);return;}
				if(['REJECTED','CANCELLED','EXPIRED'].includes(result.status)){
					const text=result.status==='REJECTED'?'主设备已拒绝本次登录':(result.status==='EXPIRED'?'登录授权已过期，请重新登录':'登录授权已取消，请重新登录');
					this.clearDeviceAuth();this.$message.warning(text);return;
				}
				this.scheduleDeviceAuthPoll();
			}).catch(error=>{
				const message = String(error && (error.message || error.msg) || '');
				if (/不存在|已处理|失效/.test(message)) {
					this.clearDeviceAuth();
					return;
				}
				this.scheduleDeviceAuthPoll();
			});
		},
		scheduleDeviceAuthPoll(){if(!this.deviceAuthWaiting)return;clearTimeout(this.deviceAuthTimer);this.deviceAuthTimer=setTimeout(()=>this.pollDeviceAuth(),2000);},
		inputBackupCode(){
			if (!this.deviceAuthRequestId) {
				return this.$message.warning('当前登录授权已失效，请重新登录');
			}
			this.backupCodeMode = true;
			this.backupCode = '';
		},
		submitBackupCode(){
			const code = String(this.backupCode || '').trim();
			if (!/^\d{6}$/.test(code)) return this.$message.warning('请输入6位数字验证码');
			this.stopDeviceAuthPoll();
			this.backupSubmitting = true;
			this.$http({url:'/login/device/authorize',method:'post',data:{requestId:this.deviceAuthRequestId,code}})
				.then(data=>{this.clearDeviceAuth();this.finishLogin(data)})
				.catch(()=>{if(this.deviceAuthWaiting)this.scheduleDeviceAuthPoll()})
				.finally(()=>{this.backupSubmitting=false});
		},
		closeBackupCode(){this.backupCodeMode=false;this.backupCode='';this.scheduleDeviceAuthPoll();},
		cancelDeviceAuth(){this.clearDeviceAuth();},
		stopDeviceAuthPoll(){clearTimeout(this.deviceAuthTimer);this.deviceAuthTimer=null;},
		clearDeviceAuth(){this.stopDeviceAuthPoll();this.deviceAuthWaiting=false;this.deviceAuthRequestId='';this.backupCodeMode=false;this.backupCode='';this.backupSubmitting=false;localStorage.removeItem(DEVICE_AUTH_REQUEST_KEY);},
		finishLogin(data) {
			this.clearDeviceAuth();
			auth.saveLoginSession(data, {autoLogin:this.isAutoLogin,userName:this.loginForm.userName});
			this.$message.success(this.$t('login.loginSuccess'));
			this.$router.push('/home/chat');
		},
		toggleLoginMode() {
			if (this.loginMode === 'password') {
				this.loginMode = 'qr';
			} else {
				this.loginMode = 'password';
			}
		},
		goBackToPassword() {
			this.loginMode = 'password';
		},
		guestLogin() {
			const consumed = localStorage.getItem('guestInviteConsumed') === '1';
			if (this.invitePolicy !== 'DISABLED' && !this.guestInviteCode && !consumed) {
				return this.$prompt('邀请码仅用于首次分配游客账号，已分配的设备再次登录无需填写。', this.invitePolicy === 'REQUIRED' ? '请输入邀请码' : '邀请码（选填）', {
					confirmButtonText: '游客登录', cancelButtonText: '取消', inputValue: '', inputValidator: value => this.invitePolicy !== 'REQUIRED' || !!String(value || '').trim() || '请输入邀请码'
				}).then(({value}) => { this.guestInviteCode=String(value||'').trim();return this.doGuestLogin(); });
			}
			return this.doGuestLogin();
		},
		doGuestLogin() {
			this.loading = true;
			this.$http({
				url: '/guest/login', method: 'post',
				data: {
					terminal: this.$enums.TERMINAL_TYPE.WEB,
					channelCode: this.$route.query.channelCode || this.$route.query.channel || '',
					inviteCode: this.guestInviteCode,
					attributionToken: localStorage.getItem('boxim.channel.attribution') || ''
				}
			}).then(data => {
				localStorage.setItem('guestInviteConsumed','1');
				this.guestInviteCode = '';
				auth.saveLoginSession(data, { autoLogin: true, userName: '' });
				this.$router.push('/home/chat');
			}).catch(() => { this.guestInviteCode=''; }).finally(() => { this.loading = false; });
		},
		autoLogin() {
			this.loading = true;
			auth.refreshLogin().then(() => {
				this.$router.push("/home/chat");
			}).catch(() => {
				auth.clearLoginSession(true);
			}).finally(() => {
				this.loading = false;
			});
		}
	},
	mounted() {
		const attributionToken = String(this.$route.query.at || '').trim();
		if (attributionToken) localStorage.setItem('boxim.channel.attribution', attributionToken);
		this.guestInviteCode = String(this.$route.query.inviteCode || this.$route.query.invite || '').trim();
		this.isAutoLogin = auth.isAutoLoginEnabled();
		this.loginForm.userName = auth.getSavedUsername();
		// 加载配置
		this.configStore.loadConfig();
		// electron 窗口大小（frame:false，即内容区尺寸；表单 380×460）
		if (window.electronAPI) {
			this.configStore.setFullScreen(false);
			window.electronAPI.sendEvent('resize', {
				width: 380 + 40,
				height: 460 + 60,
				maximizable: false
			})
		}
		if (this.restoreDeviceAuth()) {
			return;
		}
		if (this.isAutoLogin) {
			this.autoLogin();
		}
	},
	beforeDestroy(){this.stopDeviceAuthPoll();},
	computed: {
		invitePolicy() {
			return String(this.configStore.registration.invitePolicy || 'OPTIONAL').toUpperCase();
		},
		loginNamePlaceholder() {
			let mode = this.configStore.registration.mode;
			let strText = this.$t('login.userName');
			if (mode.includes("phone")) {
				strText += "/" + this.$t('register.phone')
			}
			if (mode.includes("email")) {
				strText += "/" + this.$t('register.email')
			}
			return strText;
		},
		containsPhoneMode() {
			return this.modes.includes("phone")
		},
		containsEmailMode() {
			return this.modes.includes("email")
		},
		modes() {
			return this.configStore.registration.mode || []
		},
		isEnableDemo() {
			return this.configStore.registration.guest?.enabled === true;
		}
	}
}
</script>

<style scoped lang="scss">
.login-view {
	position: relative;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	background: #fff;
	overflow: hidden;

	.content {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		z-index: 1;
	}

	.form {
		width: 380px;
		height: 460px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 32px 36px;
		background: rgba(255, 255, 255, 0.88);
		backdrop-filter: blur(24px);
		-webkit-backdrop-filter: blur(24px);
		border-radius: 28px;
		border: 1px solid rgba(255, 255, 255, 0.95);
		box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.04);
		overflow: visible;
	}

	&.electron .form {
		border-radius: 0;
		box-shadow: none;
		border: none;
	}

	.form-header {
		flex-shrink: 0;
		text-align: left;
	}

	.form-welcome {
		margin: 0 0 6px;
		font-size: 26px;
		font-weight: 700;
		letter-spacing: 0.5px;
		line-height: 1.3;
		color: var(--im-color-primary);
	}

	.form-welcome-subtitle {
		margin: 0;
		font-size: var(--im-font-size);
		color: var(--im-text-color-light);
		line-height: 1.5;
	}

	.form-body {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		min-height: 0;
	}

	.form-body ::v-deep .el-form-item {
		margin-bottom: 20px;

		.el-input__inner {
			height: 52px;
			border-radius: 50px;
			border: 1px solid rgba(0, 0, 0, 0.06);
			background: #fff;
			transition: border-color 0.2s ease, box-shadow 0.2s ease;
			padding-left: 48px;
			font-size: var(--im-font-size-large);

			&:focus {
				border-color: rgba(0, 0, 0, 0.1);
				box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.8);
			}

			&::placeholder {
				color: var(--im-text-color-lighter);
				font-size: var(--im-font-size);
			}
		}

		.el-input__prefix {
			left: 18px;
			display: flex;
			align-items: center;
			height: 100%;
		}

		.el-input__prefix .el-input__icon {
			color: var(--im-color-primary-light-3);
			font-size: 18px;
			line-height: 1;
			height: auto;
			width: auto;
		}

		.el-input__suffix {
			display: none;
		}
	}

	.nav-tool-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}

	::v-deep .nav-tool-bar .el-checkbox__label {
		color: var(--im-text-color-light);
		font-size: var(--im-font-size-small);
	}

	.link {
		text-decoration: none;
		color: var(--im-text-color-light);
		font-size: var(--im-font-size-small);
		transition: color 0.2s ease;

		&:hover {
			color: var(--im-color-primary);
		}
	}

	.qr-link {
		cursor: pointer;
		display: inline-flex;
		align-items: center;

		i {
			margin-right: 6px;
			font-size: 14px;
		}
	}

	.submit-btn {
		width: 100%;
		height: 52px;
		margin-top: 20px;
		border-radius: 50px;
		border: none;
		color: #fff;
		font-size: var(--im-font-size-larger);
		font-weight: 600;
		letter-spacing: 2px;
		transition: transform 0.2s ease, box-shadow 0.2s ease;

		&:hover {
			transform: translateY(-1px);
		}
	}

	.footer-links {
		flex-shrink: 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 20px;
		padding: 0 4px;
	}

	.demo-login-link {
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		text-decoration: none;
		color: var(--im-color-primary);
		font-size: var(--im-font-size-small);

		&:hover {
			opacity: 0.85;
		}
	}
}
.device-auth-waiting{text-align:center;color:var(--im-text-color-light);line-height:1.7}.auth-lock{display:block;font-size:44px;color:var(--im-color-primary);margin-bottom:16px}.auth-loading{display:block;margin-top:18px;font-size:24px;color:var(--im-color-primary)}
</style>
